<template>
  <sp-text :tag="tag" class="sp-subtitle" type="subtitle">
    <slot />
  </sp-text>
</template>

<script setup>
defineProps({
  tag: {
    type: String,
    default: "div",
  },
});
</script>

<style>
:host {
  display: block;
  margin: 0;
}
</style>
